export const sceneProgress = { value: 0 };
export const heroProgress = { value: 0 };
export const heroMouse = { x: 0, y: 0 };
